    $(document).ready(function() {
      // Find the number of images for both mobile and desktop carousels
      let carouselImages = document.querySelectorAll('.main-carousel .carousel-cell');
      const collectionHandle = $('.main-carousel-collection').data('collection-handle');
      let slideIntervalTime = 4000; // default 4s
      if (collectionHandle === 'gpay-b2g2') {
          slideIntervalTime = 5000; // 5s for specific collection
      }

      // Check if there's only one image in both carousels
      if (carouselImages.length <= 1) {
          console.log('Only one image detected. Skipping script.');
          return; // Exit the script
      }

      // Existing code for carousel initialization and dragging functionality

      var isDragging = false;
      var startX, scrollLeft;
      let carousel;
      let carouselItems = [];

      // Determine which carousel to use based on window size
      function setupCarousel() {
          carousel = document.querySelector('.main-carousel');
          carouselItems = document.querySelectorAll('.main-carousel .carousel-cell');

          // Ensure that carouselItems is not empty
          if (carouselItems.length === 0) {
              console.error('Carousel items not found!');
              return;
          }
          console.log("carouselItems:", carouselItems);
      }

      // Initial setup
      setupCarousel();

      // Handle resizing of the window to switch between mobile/desktop carousels
      $(window).resize(function() {
          setupCarousel();  // Reinitialize carousel on window resize
      });

      // Dragging functionality
      $('.main-carousel-collection .carousel-cell').on('mousedown', function(e) {
          isDragging = true;
          startX = e.pageX - $(this).offset().left;
          scrollLeft = $(this).parent().scrollLeft();
          $(this).css('cursor', 'grabbing');
          e.preventDefault();
      });

      $(document).on('mouseup', function() {
          isDragging = false;
          $('.main-carousel-collection .carousel-cell').css('cursor', 'grab');
      });

      $('.main-carousel-collection .carousel-cell').on('mousemove', function(e) {
          if (!isDragging) return;
          var x = e.pageX - $(this).offset().left;
          var walk = (x - startX) * 2;  // Adjust speed
          $(this).parent().scrollLeft(scrollLeft - walk);
      });

      $(document).on('mouseleave', function() {
          if (isDragging) {
              isDragging = false;
              $('.main-carousel-collection .carousel-cell').css('cursor', 'grab');
          }
      });

      // Carousel logic
      let currentIndex = 0;
      let autoSlideInterval;

      function showSlide(index) {
          currentIndex = index;
          const offset = index * carouselItems[0].clientWidth;
          carousel.scrollTo({ left: offset, behavior: 'smooth' });
      }

      function nextSlide() {
          currentIndex = (currentIndex + 1) % carouselItems.length;
          showSlide(currentIndex);
      }

      function startAutoSlide() {
          autoSlideInterval = setInterval(nextSlide, slideIntervalTime);
      }

      function stopAutoSlide() {
          clearInterval(autoSlideInterval);
      }

      function resetAutoSlide() {
          stopAutoSlide();
          startAutoSlide();
      }

      carousel.addEventListener('scroll', () => {
          const scrolledIndex = Math.round(carousel.scrollLeft / carouselItems[0].clientWidth);
          currentIndex = scrolledIndex;
          resetAutoSlide();
      }, { passive: true });

      carousel.addEventListener('mouseenter', stopAutoSlide);
      carousel.addEventListener('mouseleave', startAutoSlide);

      startAutoSlide();
  });
